import { render, staticRenderFns } from "./KotSettings.vue?vue&type=template&id=a9590926"
import script from "./KotSettings.vue?vue&type=script&lang=js"
export * from "./KotSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports